// The user manual (MANUAL, A37 (c)): a static page built by scripts/manual/build_manual.py into
// public/manual/, served beside the application - not a route of it, so it is linked with a plain
// anchor, never with the router.
export const MANUAL_PATH = "/manual/en/index.html";
